export default {
	setBarStatus(state, item) {
		state.barstatus = item;
	},
	setGlobalPickerDate(state, item) {
		state.globalRange = item;
	},
	setModalData(state, item) {
		state.modaldata = item;
	},
	setToken(state, item) {
		state.token = item;
	},

	/** Auth actions */
	logout(state) {
		state.status = '';
		state.token = '';
	},
	logoff(state) {
		state.token = '';
		this.$cookie.delete('token');
	},
	setUser(state, item) {
		state.user = item;
	},
	setLogUser(state, item) {
		state.logUser = item;
	},

	/** Fim auth */
	setRota(state, item) {
		state.rota = item;
	},
	auth_request(state) {
		state.status = 'loading';
	},
	auth_success(state, token, user) {
		state.status = 'success';
		state.token = token;
		state.user = user;
	},
	auth_error(state) {
		state.status = 'error';
	},

	setDatabase(state, item) {
		state.database = item;
	},
	setModalPessoa(state, item) {
		state.modalpessoa = item;
	},
	setModalPagamento(state, item) {
		state.modalPagamento = item;
	},

	setPedidoDataDetail(state, item) {
		state.pedidoDataDetail = item;
	},
	setPedidoEditModalPagamento(state, item) {
		state.pedidoEditModalPagamento = item;
	},
	setModalCondPagamento(state, item) {
		state.modalCondPagamento = item;
	},
	setEditModalTabVendas(state, item) {
		state.modalEditTabVendas = item;
	},
	setAddModalTabVendas(state, item) {
		state.modalAddTabVendas = item;
	},
	setUpdateAdmUserTable(state, item) {
		state.updateAdmUserTable = item;
	}
};
